import { Container } from "@mui/material";
import React from "react";
import { Banner728x90 } from "./TemuBanner";

export const adData = [
  {
    id: "1",
    name: "Сет од 5 парчиња заштитник на кабли, прекривка за заштита на кабли од ТПУ, додатоци за заштита на кабли, без батерија, за мобилни телефони, комплет за заштита на податочни линии",
    price: 54,
    originalPrice: 206,
    image:
      "https://img.kwcdn.com/product/fancy/836da07a-a093-4101-aa63-2f405e3224e8.jpg?imageView2/2/w/1300/q/90/format/webp",
    rating: 4.8,
    reviewCount: 10276,
    discount: 73,
    badge: "#1 Најпродаван артикл",
    href: "https://temu.to/k/e6rcvyz81xp",
  },
  {
    id: "2",
    name: "Држач за полнење на телефон кој се монтира на ѕид - Мултифункционален пластичен организатор за чување на покрај кревет и за ТВ далечински управувач",
    price: 56,
    originalPrice: 87,
    image:
      "https://img.kwcdn.com/product/open/2024-07-26/1721974006417-211653cc55b747ce9d9b507380e38ce7-goods.jpeg?imageView2/2/w/1300/q/90/format/webp",
    rating: 4.5,
    reviewCount: 16742,
    discount: 35,
    badge: "#1 Најпродавано",
    href: "https://temu.to/k/e8003pn9ylz",
  },
  {
    id: "3",
    name: "2W Пренослив Соларен Панел 1 парче | 5V 2W Соларно Полнач со USB Безбедносен Стабилизатор за Батерија, Полнач за Power Bank и Телефон за Надворешни Активности, Кампување и Домашна Употреба | Правоаголен Соларен Панел | Лесен Соларен Вентилатор",
    price: 195,
    originalPrice: 328,
    image:
      "https://img.kwcdn.com/product/1fee583f00/832423aa-3c61-4895-8bdd-f2b748716055_1000x1000.jpeg?imageView2/2/w/1300/q/90/format/webp",
    rating: 4.3,
    reviewCount: 3037,
    discount: 40,
    badge: "Летен избор",
    href: "https://temu.to/k/eobqit3x4mo",
  },
  {
    id: "4",
    name: "115 во 1 прецизен комплет за одвртување на шрафови, хром ванадиум челик, магнетен комплет за поправка, анти-слип, ергономска рачка, за електроника, телефони, лаптопи, часовници, шок-отпорен, куполна глава, хексагонална, пентагонална, крстосани глави, сребрено сиво",
    price: 501,
    originalPrice: 1655,
    image:
      "https://img.kwcdn.com/product/open/9c28828e7fee48eab5eb7b1269341dfe-goods.jpeg?imageView2/2/w/1300/q/90/format/webp",
    rating: 4.5,
    reviewCount: 507,
    discount: 69,
    badge: "#4 Најпродаван артикл",
    href: "https://temu.to/k/e3h667n4a8t",
  },
];

const trackTemuClick = ({ value }) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "temu_click", {
      event_category: "ad",
      event_label: "temu_button",
      value: value,
    });
  }
};

export const TopBanner = () => (
  <Container sx={{ mt: 2 }}>
    <Banner728x90
      showDots
      ctaText="Купи сега"
      onProductClick={({ id, href }) => {
        trackTemuClick({ value: id });
        window.open(href, "_blank"); // Opens in a new tab
      }}
      products={adData}
    />
  </Container>
);
